import { inject, Injectable } from '@angular/core';
import {
  MCAuthoritiesEventsGeneric,
  MCAuthoritiesEventsTabs,
  MCCustomFunctionsParams,
} from '@maslul/common-services';

@Injectable({
  providedIn: 'root',
})
export class AuthoritiesEventsTabs extends MCAuthoritiesEventsTabs {
  private authoritiesEventsGeneric = inject(MCAuthoritiesEventsGeneric);

  constructor() {
    super();
  }

  setIsNotValidRowItem(customFunctionsParams: MCCustomFunctionsParams) {
    this.authoritiesEventsGeneric.noImplementFunction(
      customFunctionsParams,
      'setIsNotValidRowItem',
    );
  }

  setIsNotValidRequestDetails(customFunctionsParams: MCCustomFunctionsParams) {
    this.authoritiesEventsGeneric.noImplementFunction(
      customFunctionsParams,
      'setIsNotValidRequestDetails',
    );
  }

  setIsNotValidAttachments(customFunctionsParams: MCCustomFunctionsParams) {
    this.authoritiesEventsGeneric.noImplementFunction(
      customFunctionsParams,
      'setIsNotValidAttachments',
    );
  }
}
